// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Expand = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M10 3h5v1h-5zM3 14h5v1H3z" />
    <path fill="currentColor" d="M14 8V3h1v5zM3 15v-5h1v5z" />
    <path stroke="currentColor" d="m14.5 3.5-11 11" />
  </svg>
);
const ForwardRef = forwardRef(Expand);
export default ForwardRef;
